<template>
  <blockquote class="blockquote text-pretty">
    <Icon
      name="mingcute:quote-left-fill"
      class="bg-muted-foreground absolute translate-y--6 top-0 left-0 -rotate-6"
      size="48"
    />
    <slot />
    <Icon
      name="mingcute:quote-right-fill"
      class="bg-muted-foreground absolute translate-y-6 bottom-0 right-0 rotate-6"
      size="48"
    />
  </blockquote>
</template>

<style scoped>
.blockquote {
  --at-apply: relative my-8 px-12 py-8 bg-muted rounded-lg;
  --at-apply: italic text-lg;

  & :deep(p) {
    --at-apply: mt-4;
  }

  & :deep(p:last-of-type > em) {
    --at-apply: block mt-4 text-muted-foreground text-base;
  }

  & :deep(p:first-of-type) {
    --at-apply: mt-0;
  }
}
</style>
